<template>
  <div>
    <div v-if='eventProgramsPageMessage' v-html='eventProgramsPageMessage' class='mb-8'></div>
    <program-schedule
      :is='eventBasedProgramSchedule'
      :default-to-today='defaultToToday'
      :show-schedule-full-width='showScheduleFullWidth'
      :program-slot-size='programSlotSize'/>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import ProgramSchedule from '@/views/gbcc2025/ProgramSchedule.vue'

export default {
  name: 'Programs',
  components: {
    ProgramSchedule,
  },
  props: [
    'defaultToToday',
    'needToBeLoggedIn',
    'showScheduleFullWidth',
    'programSlotSize',
  ],
  computed: {
    ...mapState('users', [
      'hasValidToken',
    ]),
    ...mapGetters('events', [
      'eventFileListOnPrograms',
      'eventProgramsPageMessage',
      'eventConfigProgramsCarouselSponsors',
      'showingEventId',
    ]),
    eventBasedProgramSchedule() {
      return this.showingEventId === 32 ? 'program-schedule-icola' : 'program-schedule'
    },
  },
  methods: {
    ...mapActions([
      'hideFullpageLoadingIndicator',
      'showFullpageLoadingIndicator',
    ]),
    ...mapActions('sessions', [
      'getSessions',
    ]),
    ...mapActions('users', [
      'checkTokenStatus',
    ]),
  },
  created () {
    this.checkTokenStatus().then(() => {
      if (!this.hasValidToken && this.needToBeLoggedIn) {
        this.$router.replace({name: 'Login', query: {redirect_route: 'Programs'} })
      }
    })
  },
  mounted () {
    this.showFullpageLoadingIndicator()
    this.getSessions().then(() => {
      this.hideFullpageLoadingIndicator()
    })
  },
}
</script>

<style scoped>
  .program-scale-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;  /* Hide any horizontal scroll */
  }

  .program-container {
    transform: scale(0.33);  /* Scale down everything */
    transform-origin: top left;  /* Keep layout aligned */
    width: 125vw;  /* Counteract the scale effect */
  }
</style>
